/* suite.io — Light Theme Tokens
   Matches design_principles.md exactly. All colors reference C.* tokens. */

export const C = {
  bg: "#F5F3F0",
  surface: "#FFFFFF",
  surfaceAlt: "#EDEBE8",
  border: "#E0DDD8",
  text: "#1A1A1A",
  muted: "#6B6B6B",

  // Semantic
  blue: "#3B82F6",
  green: "#10B981",
  amber: "#F59E0B",
  capture: "#D97706",
  danger: "#EF4444",
  teal: "#0D9488",
  purple: "#8B5CF6",

  // Brand / app-specific
  pink: "#E8758A",
  brown: "#8B6B4A",
  indigo: "#6366F1",
  stone: "#78716C",
};

export const font = "'DM Sans', system-ui, -apple-system, sans-serif";
export const mono = "'DM Mono', 'SF Mono', monospace";

// Shared component styles
export const inp = {
  width: "100%",
  padding: "10px 13px",
  background: C.surfaceAlt,
  border: `1px solid ${C.border}`,
  borderRadius: 6,
  color: C.text,
  fontSize: 13,
  fontFamily: font,
  fontWeight: 300,
  outline: "none",
  boxSizing: "border-box",
};

export const lbl = {
  fontSize: 11,
  fontWeight: 400,
  textTransform: "uppercase",
  letterSpacing: "0.12em",
  color: C.muted,
  marginBottom: 5,
  display: "block",
  fontFamily: font,
};

export const sel = {
  ...inp, appearance: "none",
  backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%23808080'/%3E%3C/svg%3E")`,
  backgroundRepeat: "no-repeat", backgroundPosition: "right 12px center",
  paddingRight: 30, cursor: "pointer",
};

export const btnP = {
  padding: "6px 12px",
  background: C.text,
  color: "#FFF",
  border: "none",
  borderRadius: 6,
  fontSize: 11.5,
  fontWeight: 400,
  cursor: "pointer",
  fontFamily: font,
};

export const btnS = {
  ...btnP,
  background: "transparent",
  color: C.muted,
  border: `1px solid ${C.border}`,
};

export const btnD = {
  ...btnS,
  color: C.danger,
  borderColor: "rgba(239,68,68,0.3)",
};

export const card = {
  background: C.surface,
  border: `1px solid ${C.border}`,
  borderRadius: 8,
  padding: 16,
};

// Filter chip — active inverts to dark bg + white text (ported with the CRM views)
export const chip = (active) => ({
  display: "inline-block", padding: "5px 11px", borderRadius: 5,
  fontSize: 11, fontWeight: 500, cursor: "pointer", fontFamily: font,
  background: active ? C.text : "transparent",
  color: active ? "#FFF" : C.muted,
  border: active ? "none" : `1px solid ${C.border}`,
  transition: "all 0.1s ease",
});

export const badge = (color) => ({
  display: "inline-block",
  padding: "2px 8px",
  borderRadius: 4,
  fontSize: 10,
  fontWeight: 500,
  background: `${color}12`,
  color,
  textTransform: "uppercase",
  letterSpacing: "0.08em",
});
